
import XDialog from 'vux/src/components/x-dialog/index.vue'

export default {
components: {
XDialog
},
data () {
return {}
},
props: {
show: {
default: false
}
},
methods: {
exit () {
this.$emit('update:show', false)
},
close () {
this.$emit('update:show', false)
this.$emit('close')
},
confirm () {
this.$emit('confirm')
this.$emit('update:show', false)
}
}
}



// WEBPACK FOOTER //
// ./src/components/simple/appConfirmDialog/App-confirm-dialog.vue